export default "<app-alergy-list-view></app-alergy-list-view>\r\n";